// extracted by mini-css-extract-plugin
export var divider = "_y0-0";